import { useState } from "react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Play, Monitor, Receipt, Clock } from "lucide-react";

const extractVideoId = (url) => {
  const match = url.match(/(?:v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
};

const TUTORIAL_DATA = {
  "EHR Tutorials": {
    icon: Monitor,
    subcategories: {
      All: null,
      "Access & Login": ["https://www.youtube.com/watch?v=yqSGLIU75OI"],
      Dashboard: ["https://www.youtube.com/watch?v=Dj3CGmfMIO8"],
      "Booking Appts": [
        "https://www.youtube.com/watch?v=rfyHIkjhZD0",
        "https://www.youtube.com/watch?v=rUTTL0KmrxI",
        "https://www.youtube.com/watch?v=MwfQhgRuHL0",
        "https://www.youtube.com/watch?v=KwnR8qtEsNU",
        "https://www.youtube.com/watch?v=MWFEWJy-fMg",
      ],
      "Managing Appts": [
        "https://www.youtube.com/watch?v=ktEz1t7en2A",
        "https://www.youtube.com/watch?v=6OhGXFNHDEw",
        "https://www.youtube.com/watch?v=WPZL-DLh81Y",
        "https://www.youtube.com/watch?v=glkvBbbyj_I",
      ],
      "Check-In / Check-Out": ["https://www.youtube.com/watch?v=pAtP-Lnylwg"],
      Charting: [
        "https://www.youtube.com/watch?v=DbugVlc7sJw",
        "https://www.youtube.com/watch?v=KSUTDsnNUP0",
        "https://www.youtube.com/watch?v=nQFa6YyCIqE",
        "https://www.youtube.com/watch?v=myYA6lXAzZM",
      ],
    },
  },
  "Billing Tutorials": {
    icon: Receipt,
    subcategories: {
      All: null,
      "Charge Entry": [
        "https://www.youtube.com/watch?v=K-JhcDgOIIs",
        "https://www.youtube.com/watch?v=ADRGno17lQU",
        "https://www.youtube.com/watch?v=r2Ed1X1khYY",
        "https://www.youtube.com/watch?v=LOpW6KEHpbc",
        "https://www.youtube.com/watch?v=7t1OLtJtHEQ",
        "https://www.youtube.com/watch?v=CdPHqIGTyt4",
        "https://www.youtube.com/watch?v=tESl_8vtvJg",
        "https://www.youtube.com/watch?v=uW4LHMDcuXc",
        "https://www.youtube.com/watch?v=DU2V00WMCJQ",
        "https://www.youtube.com/watch?v=LVpqAog50ew",
        "https://www.youtube.com/watch?v=K1TJ1JvgzNI",
        "https://www.youtube.com/watch?v=dSnxIFiblGI",
        "https://www.youtube.com/watch?v=x2HJzmu4x2M",
        "https://www.youtube.com/watch?v=lbzsra_8m1c",
        "https://www.youtube.com/watch?v=6TZ1vkNq_3k",
        "https://www.youtube.com/watch?v=KL3WhcLH7Lk",
        "https://www.youtube.com/watch?v=CAo50TEx600",
        "https://www.youtube.com/watch?v=5Rv1rMJiF-Y",
        "https://www.youtube.com/watch?v=u7z1A0mGwSU",
        "https://www.youtube.com/watch?v=LngDFdvJviY",
        "https://www.youtube.com/watch?v=tvRkuQqp5u8",
        "https://www.youtube.com/watch?v=_cz7e5WlK9U",
        "https://www.youtube.com/watch?v=ruS8ElXXDGs",
        "https://www.youtube.com/watch?v=UNcJ6b8UMKw",
        "https://www.youtube.com/watch?v=PmUOAAIthhE",
      ],
      "Payment Posting": [
        "https://www.youtube.com/watch?v=cu3nQVZo-Wk",
        "https://www.youtube.com/watch?v=veUcksfgooY",
        "https://www.youtube.com/watch?v=SjPbx5OoxUQ",
        "https://www.youtube.com/watch?v=qPjDe_46huc",
        "https://www.youtube.com/watch?v=wSzpzpt_Xb4",
        "https://www.youtube.com/watch?v=5yB0HDInPWs",
        "https://www.youtube.com/watch?v=MSnbpWppY3s",
        "https://www.youtube.com/watch?v=-CnSxnyiJU4",
        "https://www.youtube.com/watch?v=pdCMG5o3FW8",
        "https://www.youtube.com/watch?v=mcbDH7sNUds",
        "https://www.youtube.com/watch?v=RYm63y-ZLbM",
        "https://www.youtube.com/watch?v=9bSMMLlnDJ0",
        "https://www.youtube.com/watch?v=h_PFr4Qcmvo",
        "https://www.youtube.com/watch?v=FYC7cn9i4oY",
        "https://www.youtube.com/watch?v=EAxAAYEJk_k",
        "https://www.youtube.com/watch?v=Ozy74GlVmRU",
        "https://www.youtube.com/watch?v=exEqYJjcfYQ",
        "https://www.youtube.com/watch?v=9Dx2rH5rp3M",
        "https://www.youtube.com/watch?v=-pDSEb8KwVg",
        "https://www.youtube.com/watch?v=zZKdlcuRpG4",
        "https://www.youtube.com/watch?v=9FVZ817MJYU",
        "https://www.youtube.com/watch?v=7eA2Z-dYiLc",
        "https://www.youtube.com/watch?v=iE3c1bV_PE0",
        "https://www.youtube.com/watch?v=OGwQ4n4FP4c",
        "https://www.youtube.com/watch?v=rcr54VSAu5s",
        "https://www.youtube.com/watch?v=r-R_7vgTOMo",
        "https://www.youtube.com/watch?v=4RXtlxE9NEw",
        "https://www.youtube.com/watch?v=Ien6ipbO9WA",
        "https://www.youtube.com/watch?v=-OO87xsyiWM",
        "https://www.youtube.com/watch?v=bcZvpBYF2zw",
        "https://www.youtube.com/watch?v=SWK4OBxNnQc",
        "https://www.youtube.com/watch?v=oQJgXCbrfI8",
        "https://www.youtube.com/watch?v=J5zAVMHRMzU",
      ],
      "Financials & Reports": [
        "https://www.youtube.com/watch?v=9puc0gmi3F0",
      ],
    },
  },
};

// Precompute "All" for each main category
const MAIN_CATEGORIES = Object.keys(TUTORIAL_DATA);
MAIN_CATEGORIES.forEach((cat) => {
  const subs = TUTORIAL_DATA[cat].subcategories;
  const allVideos = [];
  Object.entries(subs).forEach(([key, urls]) => {
    if (key !== "All" && urls) allVideos.push(...urls);
  });
  subs["All"] = allVideos;
});

function VideoCard({ url, onClick }) {
  const videoId = extractVideoId(url);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      className="group cursor-pointer rounded-xl overflow-hidden bg-white hover:shadow-lg transition-all duration-200"
      style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}
      onClick={() => onClick(videoId)}
      data-testid={`tutorial-${videoId}`}
    >
      <div className="relative aspect-video bg-slate-100">
        <img src={thumbnail} alt="Tutorial" className="w-full h-full object-cover" loading="lazy" />
        {/* Duration badge */}
        <div className="absolute bottom-1.5 right-1.5 bg-black/75 text-white text-[9px] font-semibold px-1.5 py-0.5 rounded">
          <Clock className="h-2.5 w-2.5 inline mr-0.5 -mt-px" />Video
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-all flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transition-all scale-75 group-hover:scale-100 w-10 h-10 rounded-full bg-white/95 flex items-center justify-center shadow-xl">
            <Play className="h-4 w-4 text-[#1B365D] ml-0.5" />
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default function TutorialsTab() {
  const [mainCategory, setMainCategory] = useState(MAIN_CATEGORIES[0]);
  const [subCategory, setSubCategory] = useState("All");
  const [playingVideoId, setPlayingVideoId] = useState(null);

  const subcategoryNames = Object.keys(TUTORIAL_DATA[mainCategory].subcategories);
  const videos = TUTORIAL_DATA[mainCategory].subcategories[subCategory] || [];

  const handleMainCategoryChange = (cat) => {
    setMainCategory(cat);
    setSubCategory("All");
  };

  return (
    <div data-testid="tutorials-tab">
      {/* Main Category Tabs */}
      <div className="flex gap-2 mb-4">
        {MAIN_CATEGORIES.map((cat) => {
          const isActive = mainCategory === cat;
          const count = TUTORIAL_DATA[cat].subcategories["All"]?.length || 0;
          const Icon = TUTORIAL_DATA[cat].icon;
          return (
            <button
              key={cat}
              onClick={() => handleMainCategoryChange(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 flex items-center gap-2 ${
                isActive
                  ? "bg-[#1B365D] text-white shadow-md"
                  : "bg-white text-slate-600 hover:bg-slate-50"
              }`}
              style={!isActive ? { boxShadow: "0 1px 3px rgba(0,0,0,0.06)" } : {}}
              data-testid={`main-tab-${cat.toLowerCase().replace(/\s/g, "-")}`}
            >
              <Icon className="h-4 w-4" />
              {cat}
              <Badge variant="secondary" className={`text-[10px] ${isActive ? "bg-white/20 text-white" : "bg-slate-100"}`}>
                {count}
              </Badge>
            </button>
          );
        })}
      </div>

      {/* Subcategory Pills */}
      <div className="flex gap-1.5 mb-5 flex-wrap">
        {subcategoryNames.map((sub) => {
          const isActive = subCategory === sub;
          const count = TUTORIAL_DATA[mainCategory].subcategories[sub]?.length || 0;
          return (
            <button
              key={sub}
              onClick={() => setSubCategory(sub)}
              className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-200 ${
                isActive
                  ? "bg-[#0071E3] text-white"
                  : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
              data-testid={`sub-tab-${sub.toLowerCase().replace(/[\s\/]/g, "-")}`}
            >
              {sub}
              {sub !== "All" && <span className="ml-1 opacity-70">{count}</span>}
            </button>
          );
        })}
      </div>

      {/* Section Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-[#1B365D] text-sm">
          {subCategory === "All" ? mainCategory : subCategory}
        </h3>
        <span className="text-xs text-slate-400">{videos.length} video{videos.length !== 1 ? "s" : ""}</span>
      </div>

      {/* Video Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
        {videos.map((url, idx) => (
          <VideoCard key={`${url}-${idx}`} url={url} onClick={(id) => setPlayingVideoId(id)} />
        ))}
      </div>

      {videos.length === 0 && (
        <div className="text-center py-12 text-slate-400"><p className="text-sm">No videos in this category</p></div>
      )}

      {/* Video Player Modal */}
      <Dialog open={!!playingVideoId} onOpenChange={() => setPlayingVideoId(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden" data-testid="tutorial-player-modal">
          <div className="sr-only">Tutorial Video</div>
          {playingVideoId && (
            <div className="aspect-video w-full bg-black">
              <iframe
                src={`https://www.youtube.com/embed/${playingVideoId}?autoplay=1&rel=0`}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Tutorial Video"
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
